import RadioButtonCheckedRoundedIcon from "@mui/icons-material/RadioButtonCheckedRounded";
import RadioButtonUncheckedRoundedIcon from "@mui/icons-material/RadioButtonUncheckedRounded";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import useColors from "../../api/hooks/useColors";
import SvgToIcon from "../../icons/SvgToIcon";
import { icons } from "../../scenes/stack/environment/icons/iconExport";
function OptionList({
  options,
  appliedFilters,
  setAppliedFilters,
  fieldName,
  singleSelect,
}) {
  const colors = useColors();

  const handleToggleSingleSelect = (option) => {
    if (appliedFilters[fieldName][option]) {
      setAppliedFilters((prevFilters) => {
        return {
          ...prevFilters,
          [fieldName]: { [option]: false },
        };
      });
    } else {
      setAppliedFilters((prevFilters) => {
        return {
          ...prevFilters,
          [fieldName]: { [option]: true },
        };
      });
    }
  };
  const handleToggle = (optionName) => {
    const ALL = "All";
    setAppliedFilters((prevFilters) => {
      const newChecked = { ...prevFilters[fieldName] };

      if (newChecked[optionName] === undefined) {
        newChecked[optionName] = false;
      }

      newChecked[optionName] = !newChecked[optionName];

      // Toggle a simple option
      if (!(optionName.toString() === ALL)) {
        if (newChecked[optionName] === false) {
          Object.keys(newChecked).forEach((key) => {
            if (key.toString() === ALL) {
              newChecked[key] = false;
            }
          });
        } else {
          let allChecked = true;
          options.forEach((option) => {
            if (!newChecked[option.name] && !(option.name.toString() === ALL)) {
              allChecked = false;
            }
          });
          if (allChecked) {
            if (options.some((option) => option.name.toString() === ALL)) {
              newChecked[ALL] = true;
            }
          }
        }
      }
      // Toggle "All" option
      else {
        options.forEach((option) => {
          newChecked[option.name] = newChecked[optionName];
        });
      }

      return {
        ...prevFilters,
        [fieldName]: newChecked,
      };
    });
  };

  return (
    <Box
      sx={{
        maxHeight: "220px",
        overflowY: "auto",
      }}
    >
      <FormGroup
        sx={{
          "& .MuiFormControlLabel-root": {
            marginLeft: 0,
          },
        }}
      >
        {options
          .filter((option) => {
            if (option.name === "All" && options.length < 3) return false;
            else return true;
          })
          .map(({ name, label, disabled, index }) => (
            <FormControlLabel
              key={name + index}
              control={
                <Checkbox
                  checked={appliedFilters[fieldName]?.[name] || false}
                  icon={
                    singleSelect ? (
                      <Box sx={{ leftPadding: "8px" }} height={"23px"}>
                        <RadioButtonUncheckedRoundedIcon
                          sx={{ width: "16px" }}
                        />
                      </Box>
                    ) : (
                      <SvgToIcon
                        IconLogo={icons.Unchecked}
                        style={{ width: "16px" }}
                      />
                    )
                  }
                  checkedIcon={
                    singleSelect ? (
                      <Box sx={{ leftPadding: "8px" }} height={"23px"}>
                        <RadioButtonCheckedRoundedIcon
                          sx={{ width: "16px", color: colors.primary_main }}
                        />
                      </Box>
                    ) : (
                      <SvgToIcon
                        IconLogo={icons.Checked}
                        style={{ width: "16px" }}
                      />
                    )
                  }
                  onChange={() => {
                    if (!disabled) {
                      singleSelect
                        ? handleToggleSingleSelect(name)
                        : handleToggle(name);
                    }
                  }}
                  disabled={disabled}
                />
              }
              label={
                <Typography
                  variant="caption"
                  component={"div"}
                  sx={{ color: disabled ? colors.grey_48percent : "inherit" }}
                >
                  {label}
                </Typography>
              }
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                "& .MuiFormControlLabel-root": {
                  marginLeft: 0,
                },
              }}
            />
          ))}
      </FormGroup>
    </Box>
  );
}

export default OptionList;
